
import React from "react";
import { Skeleton } from "@/components/ui/skeleton";

export function OrganizationLoading() {
  return (
    <div className="space-y-4">
      <div className="flex items-center space-x-2">
        <Skeleton className="h-8 w-8" />
        <Skeleton className="h-8 w-40" />
      </div>
      <Skeleton className="h-[600px] w-full" />
    </div>
  );
}
